/** Zero-pad a number to two digits — `"9"` -> `"09"`, `"12"` unchanged. Shared by
 * `formatDateTime.ts` and `datetimeLocalInput.ts` rather than duplicated in each; the two were an
 * identical byte-for-byte copy before this file existed, which `claude-kit/rules/working-style.md`'s
 * "favor the general, reusable solution once a pattern actually recurs" flags at the *second*
 * occurrence — this is that second occurrence, in a sibling module added by the same change. */
export function pad2(value: number): string {
  return value < 10 ? `0${String(value)}` : String(value);
}
